import styled from 'styled-components';

import { Heading } from '@savgroup-front-common/core';

import { DOSSIER_RESPONSIVE_MAX_WIDTH_PX } from './DossierPage.styles';

export { DOSSIER_RESPONSIVE_MAX_WIDTH_PX };

export const $Page = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const $HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  min-width: 0;
`;

export const $HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  flex: 1;
`;

export const $Title = styled(Heading)`
  margin: 0;
  min-width: 0;
  line-height: 1.15;
`;

export const $ClientMeta = styled.p`
  margin: 0;
  min-width: 0;
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  color: ${({ theme }) => theme.colors.secondaryTextColor ?? theme.colors.mainTextColor};
  line-height: 1.15;
`;

export const $CloseButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const $PanelInner = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
